var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 106,
    viewBox: "0 0 107 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.9004 4.19922C79.8447 4.19932 102.5 26.9545 102.5 54.8994C102.5 69.0716 96.7115 81.8463 87.4297 91.0283V91.0293C78.3482 100.111 65.7734 105.6 51.9004 105.6C38.5584 105.6 26.3399 100.355 17.2412 91.8604L16.3701 91.0283C7.08848 81.8463 1.2998 69.0714 1.2998 54.8994C1.29991 26.8546 23.9558 4.19922 51.9004 4.19922Z",
    fill: "#EAEEF9",
    stroke: "black",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1996 21.6004C100.464 21.6004 102.3 19.7648 102.3 17.5004C102.3 15.236 100.464 13.4004 98.1996 13.4004C95.9352 13.4004 94.0996 15.236 94.0996 17.5004C94.0996 19.7648 95.9352 21.6004 98.1996 21.6004Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.2 5.6C105.747 5.6 107 4.3464 107 2.8C107 1.2536 105.747 0 104.2 0C102.654 0 101.4 1.2536 101.4 2.8C101.4 4.3464 102.654 5.6 104.2 5.6Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8 21.5004C4.3464 21.5004 5.6 20.2468 5.6 18.7004C5.6 17.154 4.3464 15.9004 2.8 15.9004C1.2536 15.9004 0 17.154 0 18.7004C0 20.2468 1.2536 21.5004 2.8 21.5004Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2998 28.4004H83.5C85.6538 28.4005 87.3994 30.1469 87.3994 32.3008V91.0586C78.3202 100.123 65.7577 105.601 51.8994 105.601C38.1415 105.6 25.5791 100.023 16.3994 91.0566V32.3008C16.3994 30.1469 18.1459 28.4004 20.2998 28.4004Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7451 49.7266C35.8325 39.7955 45.383 33.4085 55.3115 35.4951C58.8534 36.2541 61.9532 37.9617 64.5479 40.4297C68.7131 44.719 70.5638 50.729 69.583 56.5625L69.4795 57.124C69.1 58.7681 68.5315 60.3495 67.8359 61.8047C66.0005 65.2223 63.28 68.005 59.8662 69.7119H59.8652C56.3246 71.5454 52.1508 72.1787 47.9121 71.3564H47.9131C38.0459 69.2692 31.6583 59.6557 33.7451 49.7266Z",
    fill: "url(#paint0_linear_9864_47645)",
    stroke: "black",
    strokeWidth: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2549 41.9375C53.8618 41.9375 55.1223 43.2044 55.0879 44.8496L55.0801 45.0107L54.127 55.3105V55.3135C54.0666 56.2776 53.2201 57.0635 52.2549 57.0635C51.2897 57.0634 50.4442 56.2775 50.3838 55.3135L50.3828 55.3105L49.4297 45.0088C49.3075 43.3492 50.5976 41.9375 52.2549 41.9375Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2549 59.1719C53.4714 59.1719 54.4442 60.1448 54.4443 61.3613C54.4443 62.578 53.4715 63.5508 52.2549 63.5508C51.0384 63.5506 50.0654 62.5779 50.0654 61.3613C50.0656 60.1449 51.0385 59.172 52.2549 59.1719Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70 77.7988V82.1992H33.7998V77.7988H70Z",
    fill: "#D5DAE5",
    stroke: "black",
    strokeWidth: 0.2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1504 86.0996V90.9004H37.3496V86.0996H66.1504Z",
    fill: "#D5DAE5",
    stroke: "black",
    strokeWidth: 0.2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1504 94.0996V98.9004H45.3496V94.0996H58.1504Z",
    fill: "#D5DAE5",
    stroke: "black",
    strokeWidth: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9864_47645",
    x1: 39.4404,
    y1: 60.6094,
    x2: 64.4404,
    y2: 41.6094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDDD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481552,
    stopColor: "#FE9A79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD561F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.a6b940c50d4a3efa37e2efdd979adf55.svg";
export { ForwardRef as ReactComponent };